<template>
  <div class="calculator">
    <form ref="input-form" @reset="handleReset">
      <the-calculator-inputs-panel />
      <the-calculator-result-panel />
    </form>
  </div>
</template>

<script lang="ts">
import { RESET } from '@/store/mutations';
import { defineComponent } from 'vue';
import TheCalculatorInputsPanel from './input-panel/TheCalculatorInputsPanel.vue';
import TheCalculatorResultPanel from './result-panel/TheCalculatorResultPanel.vue';

export default defineComponent({
  name: 'calculator',
  components: { TheCalculatorResultPanel, TheCalculatorInputsPanel },
  methods: {
    handleReset() {
      this.$store.commit(RESET);
    },
  },
});
</script>

<style lang="scss" scoped>
.calculator {
  background-color: $white;
  border-radius: 2.5rem;
  padding: 2.75rem;
  margin-top: 6rem;

  form {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 2rem;

    @include phone-styles {
      align-self: stretch;

      grid-template-columns: initial;
      grid-template-rows: repeat(2, 1fr);
    }
  }

  @include phone-styles {
    padding: 3rem;
  }
}
</style>
